import { apiGet, apiPatch, apiPost } from '../shared/apiClient';
import { publishCustomerTypeChanged } from '../../../messaging/customerProfileEvents';
import { assertSessionCurrent, sessionTicket } from '../../../../utils/sessionLifecycle';

function profileResult(response) {
  const envelope = response?.data;
  if (envelope?.success !== true || !envelope.data || !Object.prototype.hasOwnProperty.call(envelope.data, 'customer')) {
    throw Object.assign(new Error(envelope?.error?.message || envelope?.message || 'Could not load customer details.'), envelope?.error);
  }
  return envelope.data;
}
const path = id => `/messaging-v1/conversations/${encodeURIComponent(id)}/customer-profile`;
async function currentResult(request) {
  const ticket = sessionTicket();
  const response = await request();
  assertSessionCurrent(ticket);
  return profileResult(response);
}
export const fetchConversationCustomerProfile = id => currentResult(() => apiGet(path(id)));
export const ensureConversationCustomerProfile = id => currentResult(() => apiPost(`${path(id)}/ensure`, {}));
export async function updateConversationCustomerType(id, type) {
  const result = await currentResult(() => apiPatch(path(id), { type }));
  if (!result.customer) throw new Error('No customer details for this chat');
  publishCustomerTypeChanged({ customerId: result.customer.customer_id, customerType: result.customer.type ?? null });
  return result;
}
export function customerProfileFailure(error) {
  const detail = error?.response?.data?.error || error;
  if (detail?.code === 'MESSAGING_CUSTOMER_IDENTITY_REQUIRED') return { status: 'no_identity', message: 'No customer details for this chat', retryable: false };
  if (['ambiguous_customer_identity', 'MESSAGING_CUSTOMER_IDENTITY_CONFLICT'].includes(detail?.code)) {
    const ids = detail.details?.customer_ids;
    const names = Array.isArray(ids) && ids.length ? ` (${ids.map(id => `#${id}`).join(', ')})` : '';
    return { status: 'conflict', message: `This chat matches more than one customer${names}. Fix the duplicate first.`, retryable: false };
  }
  if (detail?.code === 'MESSAGING_CUSTOMER_PROFILE_BUSY') return { status: 'busy', message: 'Customer details are busy. Try again.', retryable: true };
  return { status: 'error', message: 'Could not load or save customer details. Try again.', retryable: true };
}
